exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.action-sheet[data-v-2e8c9b81] {\n  background: red;\n}\n.action-sheet .left-nav-button[data-v-2e8c9b81] {\n  font-size: 0.373333rem;\n  color: #666;\n  margin-left: 0.413333rem;\n}\n.action-sheet .content[data-v-2e8c9b81] {\n  height: 18.2rem;\n  padding: 0.133333rem 0;\n}", ""]);

// exports
